import * as React from "react";
import { Check } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const curriculumHighlights = ["Microdiscectomy — from €4,500", "Nucleoplasty — from €3,600", "Vertebroplasty — from €3,300"];
export default function FiveWeekCourseDetails() {
  return <section data-section-id="115669" id="spine-surgery-procedures" className="bg-background text-foreground py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="flex flex-col lg:flex-row items-center relative">
          
          {}
          <div className="w-full lg:w-[60%] relative z-0">
            <div className="relative w-full aspect-[4/3] lg:aspect-[16/11]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626927/img/spine_surgery_kaunas.png" alt="Modern surgical facility in Kaunas" className="w-full h-full object-cover rounded-lg shadow-xl" />
              {}
              <div className="absolute inset-0 bg-primary/5 mix-blend-overlay rounded-lg pointer-events-none"></div>
            </div>
          </div>

          {}
          <div className="w-full lg:w-[45%] lg:-ml-[5%] mt-12 lg:mt-0 relative z-10">
            <Card className="bg-white border-[#f1f3f5] shadow-2xl p-8 md:p-12 rounded-lg">
              <CardContent className="p-0 flex flex-col gap-8">
                
                <div className="space-y-4">
                  <h2 className="font-default text-4xl md:text-5xl font-bold text-primary leading-tight">
                    Spine Surgery in Kaunas
                  </h2>
                  <p className="text-lg text-muted-foreground font-default">
                    Experience world-class neurosurgical excellence in Lithuania. Our specialized team delivers advanced minimally invasive treatments with a focus on rapid recovery and patient-centered care.
                  </p>
                </div>

                <ul className="space-y-4">
                  {curriculumHighlights.map((item, i) => <li key={i} data-index={i} className="flex items-center gap-4 p-4 border border-[#f1f3f5] rounded-lg bg-white transition-all hover:shadow-md hover:-translate-y-1">
                      <div className="bg-accent/50 rounded-full p-1 shadow-sm shrink-0">
                        <Check className="w-5 h-5 text-chart-2" strokeWidth={3} />
                      </div>
                      <span className="text-primary font-default font-semibold text-lg leading-snug">{item}</span>
                    </li>)}
                </ul>

                <div className="pt-8 border-t border-border mt-2">
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-6">
                    <div>
                      <div className="text-primary text-5xl font-default font-bold tracking-tight">
                        €3,200
                      </div>
                      <div className="text-sm text-muted-foreground mt-1 font-medium font-default">
                        Starting price for procedures
                      </div>
                    </div>
                    <Button size="lg" className="w-full sm:w-auto text-lg h-14 px-8 rounded-md shadow-lg bg-chart-2 text-primary hover:bg-chart-2/90 transition-all font-default font-bold">
                      Book Consultation
                    </Button>
                  </div>
                </div>

              </CardContent>
            </Card>
          </div>

        </div>
      </div>
    </section>;
}